import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M185-106q-32 0-56-23-23-24-23-56v-590q0-33 23-56 24-24 56-24h590q33 0 56 24 24 23 24 56v590q0 32-24 56-23 23-56 23H185Zm0-79h590v-590H185v590Zm0 0v-590 590Zm83-87h425q12 0 18-11 5-10-2-21L594-460q-6-8-16-8t-16 8L446-310l-76-106q-7-8-17-8t-16 8l-84 112q-8 11-3 21 6 11 18 11Z"/>',
  f: '<path d="M185-106q-32 0-56-23-23-24-23-56v-590q0-33 23-56 24-24 56-24h590q33 0 56 24 24 23 24 56v590q0 32-24 56-23 23-56 23H185Zm83-166h425q13 0 18-11 5-10-2-21L594-460q-6-8-16-8t-16 8L446-310l-76-106q-7-8-17-8t-16 8l-84 112q-8 11-3 21 5 11 18 11Z"/>',
};

export default data;
